import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { NOTIFICATION_COLORS } from '@/constants/residents/mobile/notificationColors';
import { strings } from '@/constants/residents/strings';

interface NotificationEmptyStateProps {
  /** Custom title (defaults to strings.notifications.mobile.empty.title) */
  title?: string;
  /** Custom message (defaults to strings.notifications.mobile.empty.message) */
  message?: string;
}

/**
 * NotificationEmptyState
 * 
 * Shared empty state component for notification screens and modals.
 * Shows a bell icon with title and description message.
 * Uses centralized colors and strings for consistency.
 */
export const NotificationEmptyState: React.FC<NotificationEmptyStateProps> = ({
  title = strings.notifications.mobile.empty.title,
  message = strings.notifications.mobile.empty.message,
}) => {
  return (
    <View style={styles.container}>
      {/* Icon */}
      <View style={styles.iconContainer}>
        <RESIDENTS_SVG_COMPONENTS.NOTIFICATION
          width={68}
          height={68}
          color={NOTIFICATION_COLORS.iconDefault}
        />
      </View>

      {/* Text Content */}
      <View style={styles.textContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.message}>{message}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    gap: 18,
  },
  iconContainer: {
    width: 68,
    height: 68,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    maxWidth: 240,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: NOTIFICATION_COLORS.textPrimary,
    textAlign: 'center',
    lineHeight: 24,
  },
  message: {
    fontSize: 14,
    fontWeight: '400',
    color: NOTIFICATION_COLORS.textSecondary,
    textAlign: 'center',
    lineHeight: 21,
  },
});

export default NotificationEmptyState;
